import React, { Component } from 'react';
import { VisualAid, VisualAidType } from '../types';
import { getVisualComponent } from '../registry/visualRegistry';
import { normalizeVisualType, resolveVisualProps } from './visualPropsResolver';
import { warn } from '../../utils/logger';
export const VISUAL_AID_FACTORY_SUPPORTED_TYPES = ['stairs', 'fraction', 'geo', 'decimalgrid', 'numberline', 'ratio', 'rule', 'money', 'column', 'clock', 'digitalClock', 'kofschipMnemonic', 'syllableBlocks', 'verbTable', 'circle', 'coordinateGrid', 'box3d', 'compositeShape', 'geometricShape', 'readingPassage', 'barChart', 'lineChart', 'calendar', 'thermometer', 'ruler', 'measuringCup', 'weighScale', 'equalSharing', 'percentageBar', 'fractionStrip', 'splitDiagram', 'sentenceDiagram', 'mapScale', 'protractor', 'symmetryGrid', 'numberBoard', 'speedDiagram', 'priceCompare', 'timeline', 'worldClockPanel'] as const;
export const SUPPORTED_VISUAL_AID_TYPES = VISUAL_AID_FACTORY_SUPPORTED_TYPES;
interface VisualAidFactoryProps {
  visualAid: VisualAid;
  isCorrect?: boolean;
  mode?: 'stimulus' | 'support';
}
export function shouldShowVisualAid(visualAid?: VisualAid, isCorrect?: boolean): boolean {
  if (!visualAid || !visualAid.type || !visualAid.data) return false;
  const {
    showWhen
  } = visualAid;
  if (!showWhen || showWhen === 'always') return true;
  if (showWhen === 'correct') return isCorrect === true;
  if (showWhen === 'wrong') return isCorrect === false;
  return false;
}
export function VisualAidFactory({
  visualAid,
  isCorrect,
  mode = 'support'
}: VisualAidFactoryProps) {
  if (!shouldShowVisualAid(visualAid, isCorrect)) return null;
  const type = normalizeVisualType(visualAid.type as string);
  const Component = getVisualComponent(type as VisualAidType);
  if (!Component) {
    warn(`Unknown visual aid type: ${type}`);
    return <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700 text-center" data-id="element-10124">
        Onbekend visueel type: <code className="font-mono" data-id="element-10125">{type}</code>
      </div>;
  }
  try {
    const props = resolveVisualProps(type, visualAid.data, mode);
    if (!props) return null;
    return <Component {...props} data-id="element-10126" />;
  } catch (error) {
    warn('Error rendering visual aid:', error);
    return null;
  }
}